export class ParametroUsuario {

  VALOR: string;
  DESCRIPCION_PARAMETRO: string;
  ID_PARAMETRO_CLIENTE_USUARIO: number;
  Id: number;
  NOMBRE_PARAMETRO: string;

  constructor() { }

  static toModel(json: string): ParametroUsuario {
    const data = JSON.parse(json);
    const toReturn = new ParametroUsuario();

    toReturn.Id = data.Id;
    toReturn.VALOR = data.VALOR;
    toReturn.DESCRIPCION_PARAMETRO = data.DESCRIPCION_PARAMETRO;
    toReturn.ID_PARAMETRO_CLIENTE_USUARIO = data.ID_PARAMETRO_CLIENTE_USUARIO;
    toReturn.NOMBRE_PARAMETRO = data.NOMBRE_PARAMETRO;

    return toReturn;
  }

}
